import React from "react";

export class PrivacyPolicyDE extends React.Component {
    render() {
        return (
            <>
                <p>
                    Letztes Update: <b>28/01/2025</b>
                    <br />
                    <br />
                </p>
                <p>
                    DH Healthcare GmbH, ein Unternehmen der Dedalus-Gruppe, misst dem Schutz Ihrer persönlichen Daten und der Wahrung Ihrer Privatsphäre große Bedeutung bei und
                    beabsichtigt, ihm besondere Aufmerksamkeit zu schenken.
                    <br />
                    <br />
                    Das Ziel dieser Datenschutzerklärung und des Informationsvermerks für die Nutzer der Website (im Folgenden als "Hinweis" bezeichnet) ist es daher, Sie darüber
                    zu informieren, wie Ihre personenbezogenen Daten verarbeitet werden, wenn Sie unser Portal z. B. secure.pacsonweb.com (im Folgenden als "Website" bezeichnet)
                    nutzen.
                    <br />
                    <br />
                    In diesem Zusammenhang weisen wir Sie darauf hin, dass Dedalus als Verantwortlicher (Controller) für Ihre personenbezogenen Daten fungiert (im Folgenden als
                    "wir", "uns" und "unser" bezeichnet).
                    <br />
                    <br />
                    DH Healthcare GmbH bestätigt ausdrücklich, dass alle personenbezogenen Daten soweit möglich und wünschenswert in Übereinstimmung mit der Verordnung 2016/679 vom
                    27. April 2016 über den Schutz natürlicher Personen bei der Verarbeitung personenbezogener Daten und zum freien Datenverkehr verarbeitet werden. Da dieses Thema
                    von großer Bedeutung ist, nehmen Sie sich bitte die Zeit, um dieses Dokument aufmerksam durchzulesen.
                </p>
                <h2>REICHWEITE DER VORLIEGENDEN DATENSCHUTZRICHTLINIE</h2>
                <p>Diese Datenschutzrichtlinie bezieht sich</p>
                <ul>
                    <li>
                        auf alle persönlichen Informationen, die von den Nutzern der DeepUnity PACSonWEB-Plattform erhoben werden. Dazu gehören sowohl registrierte Ärzte,
                        Zahnärzte, Fachärzte etc., die DeepUnity PACSonWEB über ein Benutzerkonto verwenden, als auch nicht registrierte Benutzer, die eine Untersuchung anhand
                        einer Referenznummer und eines Geburtsdatums öffnen.
                    </li>
                    <li>auf alle Allgemeinen Bedingungen und anderen Grundregeln von DH Healthcare GmbH, die sich auf die zur Verfügung gestellten Dienstleistungen beziehen.</li>
                </ul>
                <p>
                    Diese Datenschutzrichtlinie bezieht sich nicht auf die Patientendaten, die DH Healthcare GmbH im Auftrag angeschlossener Krankenhäuser und Radiologieabteilungen
                    verarbeitet. Dazu gehören sowohl medizinische Daten, die von der radiologischen Abteilung generiert werden, als auch medizinische Daten, die der Patient selbst
                    über die Upload-Funktion einer radiologischen Abteilung zur Verfügung stellt. Dafür möchten wir Sie auf die Datenschutzrichtlinie der betreffenden
                    Radiologieabteilung verweisen.
                </p>
                <h2>1. WELCHE PERSONENBEZOGENEN DATEN SAMMELN WIR?</h2>
                <p>
                    Wenn Sie unser Portal nutzen, können wir die folgenden Kategorien personenbezogener Daten über Sie erfassen:
                    <br />
                    Identifikationsdaten (z. B. Name, Vorname, E-Mail-Adresse, Benutzername, Passwort, Region, Gerätetyp);
                    <br />
                    berufliche Daten (z. B. Position, Tätigkeitsbereich, Arbeitgeber);
                    <br />
                    technische Daten (z. B. IP-Adresse, Art des verwendeten Browsers, Zeitpunkt der Anmeldung zum Portal) und
                    <br />
                    alle personenbezogenen Daten, die in der Korrespondenz enthalten sind, die Sie an uns senden.
                    <br />
                    <br />
                    Die Angabe Ihrer personenbezogenen Daten ist freiwillig, aber ohne sie können wir Ihnen die von Ihnen gewünschten Dienstleistungen und Informationen nicht zur
                    Verfügung stellen. Wenn Sie uns beispielsweise über die Website kontaktieren, müssen Sie uns Ihre E-Mail-Adresse mitteilen, damit wir Ihnen antworten können.
                    <br />
                    <br />
                    In jedem Fall werden wir Sie informieren, wenn die Angabe Ihrer personenbezogenen Daten erforderlich ist.
                    <br />
                    <br />
                    Wenn Sie uns personenbezogene Daten von Dritten zur Verfügung stellen, verpflichten Sie sich außerdem, dafür zu sorgen, dass diese Personen ordnungsgemäß über
                    die Verarbeitung ihrer personenbezogenen Daten in Übereinstimmung mit dieser Richtlinie informiert wurden und, falls erforderlich, in die Verarbeitung ihrer
                    personenbezogenen Daten eingewilligt haben.
                </p>
                <h2>2. WOZU VERWENDEN WIR IHRE PERSONENBEZOGENEN DATEN?</h2>
                <p>
                    In der nachstehenden Tabelle sind die Zwecke aufgeführt, für die wir Ihre personenbezogenen Daten verarbeiten, sowie für jeden Zweck die Rechtsgrundlage für die
                    jeweilige Verarbeitung:
                </p>
                <table>
                    <thead>
                        <tr>
                            <th>ZWECK</th>
                            <th>GRUNDLAGE</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                Registrierung eines Benutzerkontos mit Implementierung entsprechender sicherer Authentifizierungs- und Autorisierungsmethoden. Dazu gehört zum
                                Beispiel das Versenden von E-Mails oder Textnachrichten für Zwei-Faktor-Authentifizierungsprotokolle;
                            </td>
                            <td>Die Verarbeitung beruht auf Ihrer Einwilligung.</td>
                        </tr>
                        <tr>
                            <td>Automatisches Senden von E-Mails, wenn eine neue Studie für den Benutzer in DeepUnity PACSonWEB verfügbar ist;</td>
                            <td>Die Verarbeitung beruht auf Ihrer Einwilligung.</td>
                        </tr>
                        <tr>
                            <td>Nachverfolgbarkeit vom registrierten Zugang bis zur medizinischen Information;</td>
                            <td>Die Verarbeitung ist erforderlich, um den gesetzlichen Verpflichtungen nachzukommen, denen wir unterliegen.</td>
                        </tr>
                        <tr>
                            <td>
                                Bereitstellung einer Liste registrierter Benutzer für Krankenhäuser, die DeepUnity PACSonWEB für die Verteilung verwenden. Diese Liste enthält nur
                                Name, Vorname und Identifikationsnummer als Arzt (RIZIV, BIG, ...)
                            </td>
                            <td>Die Verarbeitung beruht auf unserem berechtigten Interesse, unsere Kunden über die Nutzung der angebotenen Dienste zu informieren.</td>
                        </tr>
                        <tr>
                            <td>
                                Beantwortung von Anfragen und Fragen, die Sie über die Website einreichen, und, allgemeiner ausgedrückt, Verwaltung unserer Beziehungen zu den
                                Besuchern der Website
                            </td>
                            <td>Erbringung der angeforderten Dienstleistung</td>
                        </tr>
                        <tr>
                            <td>Verbesserung unserer Dienstleistungen und unserer Website</td>
                            <td>
                                Optimierung unsere Tools und Lösungen so zu optimieren, so dass sie unseren Website-Besuchern, Kunden und Interessenten am besten gerecht werden
                            </td>
                        </tr>
                        <tr>
                            <td>Einhaltung der für uns geltenden rechtlichen und regulatorischen Verpflichtungen</td>
                            <td>Erfüllung von gesetzlichen Verpflichtungen</td>
                        </tr>
                        <tr>
                            <td>Verwaltung potenzieller oder tatsächlicher Streitigkeiten mit Ihnen oder Dritten</td>
                            <td>Verteidigung unserer rechtlichen Interessen</td>
                        </tr>
                        <tr>
                            <td>
                                Versenden von Marketingnachrichten und Werbebotschaften über unsere Aktivitäten, Produkte und Dienstleistungen und die der anderen Unternehmen der
                                Dedalus-Gruppe (einschließlich Marktforschung, Umfragen zur Kundenzufriedenheit, Informationen über Webinare und Veranstaltungen) sowohl auf
                                automatisiertem (z. B. E-Mail, SMS, MMS) als auch auf nicht automatisiertem Weg (z. B. Telefon, Post)
                            </td>
                            <td>Ihre ausdrückliche Zustimmung, falls Sie diese erteilen</td>
                        </tr>
                        <tr>
                            <td>
                                Weitergabe Ihrer personenbezogenen Daten an andere Unternehmen der Dedalus-Gruppe, die in Ihrem Land/Ihrer Region ansässig sind, damit diese Ihnen
                                mit Hilfe automatisierter Mittel (z. B. E-Mail, SMS, MMS) Marketingnachrichten und Werbebotschaften über ihre Aktivitäten, Produkte und
                                Dienstleistungen (einschließlich Marktforschung, Umfragen zur Kundenzufriedenheit, Informationen über Webinare und Veranstaltungen) senden können
                            </td>
                            <td>Ihre ausdrückliche Zustimmung, falls Sie diese erteilen</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    Bitte beachten Sie in jedem Fall, dass wir Ihre personenbezogenen Daten nicht für andere Zwecke verarbeiten, die mit den oben genannten Zwecken unvereinbar
                    sind.
                </p>
                <h2>3. AN WEN GEBEN WIR IHRE PERSONENBEZOGENEN DATEN WEITER?</h2>
                <p>
                    Im Rahmen unserer Verarbeitungen können wir Ihre personenbezogenen Daten an die folgenden Empfänger weitergeben:
                    <br />• unseren Dienstleistern, Lieferanten, Vertretern und Auftragnehmern, soweit sie uns bei der Erfüllung der in dieser Richtlinie genannten Zwecke
                    unterstützen (z. B. setzen wir IT-Dienstleister ein, um Ihre personenbezogenen Daten in unserem Auftrag zu hosten);
                    <br />• an die anderen Unternehmen der Dedalus Gruppe, soweit sie uns bei der Erfüllung der in dieser Richtlinie genannten Zwecke unterstützen.
                    <br />• an zuständige Gerichte, Behörden, Regierungsstellen und Strafverfolgungsbehörden (ein-schließlich der Fälle, in denen wir gesetzlichen oder behördlichen
                    Aufforderungen nachkommen müssen).
                    <br />
                    <br />
                    Ungeachtet des Empfängers werden wir Ihre personenbezogenen Daten nur auf der Grundlage der Notwendigkeit der Kenntnisnahme und nur in dem Umfang weitergeben,
                    der zur Erfüllung der in dieser Richtlinie genannten Zwecke erforderlich ist.
                    <br />
                    <br />
                    Wir verkaufen Ihre personenbezogenen Daten nicht.
                </p>
                <h2>4. ÜBERMITTELN WIR DATEN AUSSERHALB DES EUROPÄISCHEN WIRTSCHAFTSRAUMES?</h2>
                <p>
                    Für alle Länder innerhalb des Europäischen Wirtschaftsraums gilt, dass personenbezogene Gesundheitsdaten, die von DeepUnity PACSonWEB verarbeitet werden, nicht in Länder außerhalb dieses Raums übermittelt werden.
                </p>
                <p>
                    Sollten Ihre personenbezogenen Daten in Länder außerhalb des Europäischen Wirtschaftsraums (“EWR”) übermittelt werden, stellen wir sicher, dass das
                    Schutzniveau, das Ihren personenbezogenen Daten gewährt wird, durch eine solche Übermittlung nicht beeinträchtigt wird.
                </p>
                <p>Dies bedeutet insbesondere, dass jede der beabsichtigten Übermittlungen auf mindestens einem der folgenden Mechanismen beruht:</p>
                <ul>
                    <li>das Vorliegen eines Angemessenheitsbeschlusses der Europäischen Kommission für das Land, in das Ihre personenbezogenen Daten übermittelt werden oder</li>
                    <li>der Abschluss von Standardvertragsklauseln, die den von der Europäischen Kommission angenommenen Mustern entsprechen oder</li>
                    <li>
                        das Vorliegen einer Ausnahmeregelung in Bezug auf eine der spezifischen Situationen, die in der Allgemeinen Datenschutzverordnung 2016/679 (“DSGVO”)
                        abschließend aufgeführt sind (z. B. wenn Sie Ihre Zustimmung zu einer solchen Übermittlung gegeben haben; nachdem Sie über das Fehlen von Garantien
                        informiert wurden; wenn die Übermittlung für die Erfüllung eines zwischen Ihnen und uns geschlossenen Vertrags erforderlich ist; wenn die Übermittlung für
                        den Abschluss oder die Erfüllung eines in Ihrem Interesse geschlossenen Vertrags zwischen uns und einem Dritten erforderlich ist oder wenn die Übermittlung
                        für die Begründung, Ausübung oder Verteidigung unserer Rechtsansprüche erforderlich ist).
                    </li>
                </ul>
                <h2>5. WIE LANGE SPEICHERN WIR IHRE PERSONENBEZOGENEN DATEN?</h2>
                <p>
                    Wir speichern Ihre personenbezogenen Daten nicht länger, als es für den Zweck der jeweiligen Verarbeitung erforderlich ist.
                    <br />
                    <br />
                    Das bedeutet, dass die Aufbewahrungsfristen je nach dem Zweck, zu dem wir die betreffenden Daten verarbeiten, unterschiedlich sind. In der nachstehenden Tabelle
                    ist daher für jeden Zweck angegeben, wie lange Ihre personenbezogenen Daten gespeichert werden:
                </p>
                <table>
                    <thead>
                        <tr>
                            <th>ZWECK</th>
                            <th>SPEICHERDAUER</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                Registrierung eines Benutzerkontos mit Implementierung entsprechender sicherer Authentifizierungs- und Autorisierungsmethoden. Dazu gehört zum
                                Beispiel das Versenden von E-Mails oder Textnachrichten für Zwei-Faktor-Authentifizierungsprotokolle;
                            </td>
                            <td>
                                Daten, die wir im Rahmen der Nutzerkontoregistrierung erhalten, werden nach dem letzten erfolgreichen Anmeldevorgang für einen Zeitraum von 2 Jahren
                                aufbewahrt.
                            </td>
                        </tr>
                        <tr>
                            <td>Automatisches Senden von E-Mails, wenn eine neue Studie für den Benutzer in DeepUnity PACSonWEB verfügbar ist;</td>
                            <td>
                                Daten, die wir im Rahmen der Nutzerkontoregistrierung erhalten, werden nach dem letzten erfolgreichen Anmeldevorgang für einen Zeitraum von 2 Jahren
                                aufbewahrt.
                            </td>
                        </tr>
                        <tr>
                            <td>Nachverfolgbarkeit vom registrierten Zugang bis zur medizinischen Information;</td>
                            <td>10 Jahren</td>
                        </tr>
                        <tr>
                            <td>
                                Bereitstellung einer Liste registrierter Benutzer für Krankenhäuser, die DeepUnity PACSonWEB für die Verteilung verwenden. Diese Liste enthält nur
                                Name, Vorname und Identifikationsnummer als Arzt (RIZIV, BIG, ...)
                            </td>
                            <td>
                                Daten, die wir im Rahmen der Nutzerkontoregistrierung erhalten, werden nach dem letzten erfolgreichen Anmeldevorgang für einen Zeitraum von 2 Jahren
                                aufbewahrt.
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Beantwortung von Anfragen und Fragen, die Sie über die Website einreichen, und, allgemeiner ausgedrückt, Verwaltung unserer Beziehungen zu den
                                Besuchern der Website
                            </td>
                            <td>Wir speichern Ihre persönlichen Daten für maximal 2 Jahre ab unserem letzten Kontakt mit Ihnen</td>
                        </tr>
                        <tr>
                            <td>Verbesserung unserer Dienstleistungen und unserer Website</td>
                            <td>
                                Wir speichern Ihre Daten für maximal ein Jahr, wobei Ihre Daten in den meisten Fällen kurz nach der Erhebung zu nicht identifizierbaren Statistiken
                                zusammengefasst werden
                            </td>
                        </tr>
                        <tr>
                            <td>Einhaltung der für uns geltenden rechtlichen und regulatorischen Verpflichtungen</td>
                            <td>Wir speichern Ihre personenbezogenen Daten so lange, wie wir den entsprechenden gesetzlichen oder behördlichen Verpflichtungen unterworfen sind</td>
                        </tr>
                        <tr>
                            <td>Verwaltung potenzieller oder tatsächlicher Streitigkeiten mit Ihnen oder Dritten</td>
                            <td>Ihre personenbezogenen Daten werden gespeichert, bis alle möglichen Rechtsmittel ausgeschöpft sind</td>
                        </tr>
                        <tr>
                            <td>
                                Versenden von Marketingnachrichten und Werbebotschaften über unsere Aktivitäten, Produkte und Dienstleistungen und die der anderen Unternehmen der
                                Dedalus-Gruppe (einschließlich Marktforschung, Umfragen zur Kundenzufriedenheit, Informationen über Webinare und Veranstaltungen) sowohl auf
                                automatisiertem (z. B. E-Mail, SMS, MMS ) als auch auf nicht automatisiertem Weg (z. B. Telefon, Post)
                            </td>
                            <td>Wir werden Ihre personenbezogenen Daten so lange verarbeiten, bis Sie Ihre Einwilligung widerrufen</td>
                        </tr>
                        <tr>
                            <td>
                                Weitergabe Ihrer personenbezogenen Daten an andere Unternehmen der Dedalus-Gruppe, die in Ihrem Land/Ihrer Region ansässig sind, damit diese Ihnen
                                mit Hilfe automatisierter Mittel (z. B. E-Mail, SMS, MMS) Marketingnachrichten und Werbebotschaften über ihre Aktivitäten, Produkte und
                                Dienstleistungen (einschließlich Marktforschung, Umfragen zur Kundenzufriedenheit, Informationen über Webinare und Veranstaltungen) senden können
                            </td>
                            <td>Wir werden Ihre personenbezogenen Daten so lange verarbeiten, bis Sie Ihre Einwilligung widerrufen</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    In jedem Fall werden wir Ihre personenbezogenen Daten nach Ablauf der geltenden Aufbewahrungsfrist unwiderruflich löschen oder anonymisieren, so dass Sie nicht
                    mehr identifiziert werden können.
                </p>
                <h2>6. BENUTZEN WIR COOKIES?</h2>
                <p>
                    Wir verwenden Cookies auf unserer Website.
                    <br />
                    Weitere Informationen über die von uns verwendeten Cookies und die Zwecke, für die wir sie einsetzen, finden Sie in unserer Cookie-Richtlinie
                </p>
                <h2>7. WELCHE RECHTE HABEN SIE?</h2>
                <p>
                    Gemäß dem geltenden Rechtsrahmen für den Datenschutz, insbesondere der Datenschutz-Grundverordnung, haben Sie als betroffene Person die folgenden Rechte:
                    <br />
                    <br />
                    Sie können Auskunft über Ihre personenbezogenen Daten verlangen und deren Berichtigung oder Löschung fordern:
                    <br />
                    <br />
                    Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen oder dieser zu widersprechen;
                    <br />
                    Sie haben das Recht auf Übertragbarkeit Ihrer personenbezogenen Daten;
                    <br />
                    Sofern die Verarbeitung Ihrer personenbezogenen Daten auf Ihrer Einwilligung beruht, beachten Sie bitte, dass Sie Ihre Einwilligung jederzeit widerrufen können,
                    ohne dass die Rechtmäßigkeit der auf Ihrer Einwilligung beruhenden Verarbeitung, die vor Ihrem Widerruf erfolgt ist, berührt wird.
                    <br />
                    Bitte beachten Sie jedoch, dass einige der oben genannten Rechte besonderen Bedingungen unterliegen, die durch den geltenden Rechtsrahmen für den Datenschutz
                    vorgegeben sind. Wenn Ihr spezieller Fall diese Bedingungen nicht erfüllt, können wir Ihrem Wunsch leider nicht nachkommen.
                    <br />
                    <br />
                    Um Ihre Rechte auszuüben, wenden Sie sich bitte an unseren DSB unter den in Abschnitt 8 (Wie können Sie uns kontaktieren?) angegebenen Kontaktdaten. Um Ihre
                    Anfrage so effizient wie möglich bearbeiten zu können, bitten wir Sie möglicherweise um bestimmte zusätzliche Informationen, um Ihre Identität zu bestätigen
                    und/oder die personenbezogenen Daten, die Gegenstand Ihrer Anfrage sind, zu finden.
                    <br />
                    <br />
                    Bitte beachten Sie in jedem Fall, dass Sie eine Beschwerde bei der zuständigen Datenschutzaufsichtsbehörde einreichen können. Eine Liste der Datenschutzbehörden
                    finden Sie unter https://ec.europa.eu/justice/article-29/structure/data-protection-authorities/index_en.htm
                </p>
                <h2>8. WIE KÖNNEN SIE UNS KONTAKTIEREN?</h2>
                <p>
                    Ihre personenbezogenen Daten werden von dem Unternehmen der Dedalus Gruppe verarbeitet, mit dem Sie ein vertragliches/vorvertragliches Verhältnis eingegangen
                    sind und das als für die Verarbeitung Verantwortlicher fungiert. Der für die Verarbeitung Verantwortliche kann unter der Adresse seines eingetragenen Sitzes
                    kontaktiert werden, die auf der jeweiligen Website und in den Vertragsunterlagen angegeben ist.
                    <br />
                    <br />
                    Wir haben auch einen Datenschutzbeauftragten (“DSB“) ernannt, den Sie per E-Mail unter der folgenden Adresse erreichen können:
                    <br />
                    für Dedalus S.p.A.: dpo.group@dedalus.eu
                    <br />
                    für andere Unternehmen mit Sitz in Italien dpo@dedalus.eu
                    <br />
                    für Unternehmen mit Sitz im Vereinigten Königreich dpo-uk@dedalus.com
                    <br />
                    für Unternehmen mit Sitz in Frankreich dpo.france@dedalus.eu
                    <br />
                    für Unternehmen mit Sitz in Deutschland/Österreich und der Schweiz dpo.dach@dedalus.com
                    <br />
                    für DH Healthcare GmbH und andere Unternehmen mit Sitz in Belgien dpo.belgium@dedalus.eu
                    <br />
                    für andere Unternehmen dpo.group@dedalus.eu
                </p>
            </>
        );
    }
}
